import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge, Button } from 'components/ui';
import { getSclaAppBackgroundPath, withSclaCohortYear } from 'utils/navigation';
import {
  isSclaReturnerAppType,
  sclaApplicationStatusLabel,
  type SclaApplicationStatusLabel,
} from 'utils/sclaApplicationKind';
import type { SclaApplicationSummary } from '../../api/listSclaApplications';
import formatSclaDate from './formatSclaDate';
import styles from './SclaHome.module.scss';

const STATUS_TONE = {
  'not started': 'neutral',
  'in progress': 'warning',
  submitted: 'brand',
} as const;

const STATUS_TEXT: Record<SclaApplicationStatusLabel, string> = {
  'not started': 'Not started',
  'in progress': 'In progress',
  submitted: 'Submitted',
};

interface ISclaPastApplicationsProps {
  applications: SclaApplicationSummary[];
}

export default function SclaPastApplications({
  applications,
}: ISclaPastApplicationsProps) {
  const navigate = useNavigate();

  return (
    <section className={styles.card}>
      <h2 className={`${styles.sectionTitle} txt-heading`}>Past applications</h2>
      {applications.length === 0 ? (
        <p className={styles.muted}>No past applications.</p>
      ) : (
        <div>
          <div className={styles.pastHead}>
            <span>Year</span>
            <span>Type</span>
            <span>Status</span>
            <span>Submitted</span>
            <span />
          </div>
          {applications.map(application => {
            const status = sclaApplicationStatusLabel(application);
            const year = application.cohortYear || '';
            return (
              <div className={styles.pastRow} key={application._id}>
                <span>
                  <span className={styles.pastLabel}>Year</span>
                  {year}
                </span>
                <span>
                  <span className={styles.pastLabel}>Type</span>
                  {isSclaReturnerAppType(application.appType) ? 'TXTer' : ''}
                </span>
                <span>
                  <span className={styles.pastLabel}>Status</span>
                  <Badge tone={STATUS_TONE[status]}>{STATUS_TEXT[status]}</Badge>
                </span>
                <span>
                  <span className={styles.pastLabel}>Submitted</span>
                  {application.submissionTimestamp
                    ? formatSclaDate(application.submissionTimestamp)
                    : 'Not submitted'}
                </span>
                <Button
                  variant="secondary"
                  onClick={() =>
                    navigate(
                      withSclaCohortYear(getSclaAppBackgroundPath(), year),
                    )
                  }
                >
                  View
                </Button>
              </div>
            );
          })}
          <p className={styles.muted}>
            Past applications are read-only. Cycles that are closed cannot be
            started or edited.
          </p>
        </div>
      )}
    </section>
  );
}
